import client from '../api-client';
import get from '../../helpers/get';

export default async function getConnectionsByNetwork(url, normalizer, path) {
  try {
    const response = await client(url);
    const responseItems = get(response, path, []);

    return responseItems.map(normalizer);
  } catch (error) {
    return [];
  }
}
